import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import LoadingWizard from '../../components/spinner/wizard';
import SectionHeader from '../../components/views/SectionHeader';
import SectionFooter from '../../components/views/SectionFooter';
import TabsContainer from '../../components/views/TabsContainer';
import InputField from '../../components/inputs/inputField';
import TimeField from '../../components/inputs/timeField';

import moment from 'moment';

const tabs = [
	{ id: 'submission', title: 'Submission Data' },
	{ id: 'calendar', title: 'Requested Times' },
	{ id: 'requestedCalendars', title: 'Requested Calendars' }
];

class RequestDetail extends Component {
	constructor(props) {
		super(props);

		const {
			match: { params },
			requests,
		} = this.props;
		const request = requests.find((r) => r._id === params.requestId);
		this.props.setActiveRow(params.requestId);

		this.state = {
			selectedSection: 'submission',
			loading: false,
			request: request,
			editing: false,
			submitting: false,
			requestedCalendarsView: {}
		};
	}

	componentDidMount() {
		const { match: { params } } = this.props;
		this.props.setActiveRow(params.requestId);
	}

	componentWillUnmount() {
		this.props.setActiveRow(null);
	}

	componentDidUpdate(prevProps) {
		const { match: { params }, requests } = this.props;
		if (prevProps.requests !== requests) {
			const updatedRequest = requests.find((r) => r._id === params.requestId);
			if (updatedRequest && updatedRequest !== this.state.request) {
				this.setState({ request: updatedRequest });
			}
		}
	}

	updateSelected = (_index, id) => {
		this.setState({ selectedSection: id });
	};

	// Check if a registrant has conflicting bookings at the same time
	hasRegistrantConflict = (currentRequest, date, timeSlot) => {
		const { bookingPage } = this.props;

		if (!bookingPage?.requests || !currentRequest) return false;

		const currentUserId = currentRequest.userId;
		const currentEmail = currentRequest.submission?.formData?.email;

		// Find all approved bookings for this registrant at the same date/time
		return bookingPage.requests.some(request => {
			// First try to match by userId, then fall back to email
			let isMatchingRegistrant = false;

			if (currentUserId && request.userId) {
				isMatchingRegistrant = request.userId === currentUserId;
			} else if (currentEmail && request.submission?.formData?.email) {
				isMatchingRegistrant = request.submission.formData.email === currentEmail;
			}

			if (!isMatchingRegistrant) return false;

			// Check if this registrant has any approved bookings at the same time
			if (request.approvedTimes && request.approvedTimes[date]) {
				return Object.keys(request.approvedTimes[date]).some(calId => {
					return request.approvedTimes[date][calId].includes(timeSlot);
				});
			}

			return false;
		});
	};

	approveTimeSlot = (requestId, date, calendarId, timeSlot) => {
		// Implementation for approving a time slot
		console.log('Approve:', { requestId, date, calendarId, timeSlot });

		// Find the request to get the userId
		const { request } = this.state;

		if (request) {
			// Check for registrant conflicts
			const hasConflict = this.hasRegistrantConflict(request, date, timeSlot);

			if (hasConflict) {
				alert('Cannot approve: This registrant already has an approved booking at this time.');
				return;
			}
		}

		// This would typically make an API call to approve the slot
		if (this.props.onApproveTimeSlot) {
			this.props.onApproveTimeSlot(requestId, date, calendarId, timeSlot);
		}
	};

	denyTimeSlot = (requestId, date, calendarId, timeSlot) => {
		// Implementation for denying a time slot
		console.log('Deny:', { requestId, date, calendarId, timeSlot });
		// This would typically make an API call to deny the slot
		if (this.props.onDenyTimeSlot) {
			this.props.onDenyTimeSlot(requestId, date, calendarId, timeSlot);
		}
	};

	isTimeSlotBooked = (calendarId, date, timeSlot) => {
		const { bookingPage } = this.props;
		if (!bookingPage?.calendars) return false;

		const calendar = bookingPage.calendars.find(cal => cal._id === calendarId);
		if (!calendar?.bookedSpots) return false;

		console.log('Checking booked spots for calendar:', calendarId, 'on date:', date, 'for time slot:', timeSlot);
		console.log('Booked spots:', calendar.bookedSpots);

		// Check if this time slot is already booked
		return calendar.bookedSpots.some(booking =>
			booking.date === date && booking.timeSlot === timeSlot
		);
	};

	renderSubmissionData = () => {
		const { request } = this.state;
		const { bookingPage } = this.props;

		if (!request?.submission) {
			return <div className="sectionBlock">No submission data available</div>;
		}

		const { submission } = request;

		return (
			<div className="sectionBody pt-0">
				<div className="sectionBlock">
					<h2 className="blockHeader">Contact Information</h2>
					<InputField
						label="First Name"
						value={submission.formData?.firstName || ''}
						disabled={true}
						inputIcon={<i className="las la-lock" />}
					/>
					<InputField
						label="Last Name"
						value={submission.formData?.lastName || ''}
						disabled={true}
						inputIcon={<i className="las la-lock" />}
					/>
					<InputField
						label="Email"
						value={submission.formData?.email || ''}
						disabled={true}
						inputIcon={<i className="las la-lock" />}
					/>
					<InputField
						label="Company"
						value={submission.formData?.name || ''}
						disabled={true}
						inputIcon={<i className="las la-lock" />}
					/>
				</div>

				{bookingPage?.form?.pages?.map((page, pageIndex) => (
					<div key={pageIndex} className="sectionBlock">
						<h2 className="blockHeader">{page.title}</h2>
						{page.sections?.map((section, sectionIndex) => (
							<div key={sectionIndex}>
								{section.title && (
									<h3 className="mb-10" dangerouslySetInnerHTML={{ __html: section.title }} />
								)}
								{section.fields?.map((field, fieldIndex) => {
								let value = submission.formData?.[field.id] || '';
								if(field.id === "reservedDateTimes" && value){
									try {
										const reservations = JSON.parse(value);
										value = reservations.map(reservation => 
											`Start Date: ${reservation.startDate} Start Time: ${reservation.startTime}\n End Date: ${reservation.endDate} End Time: ${reservation.endTime}`
										).join(',\n');
									} catch (e) {
										console.error('Error parsing reservedDateTimes:', e);
									}
								}
									return (
										<InputField
											key={fieldIndex}
											label={field.label}
											value={value}
											disabled={true}
											inputIcon={<i className="las la-lock" />}
										/>
									);
								})}
							</div>
						))}
					</div>
				))}

				<div className="sectionBlock">
					<h2 className="blockHeader">Submission Info</h2>
					<InputField
						label="Submitted Date"
						value={moment(submission.submittedAt).format("MM/DD/YYYY h:mm a")}
						disabled={true}
						inputIcon={<i className="las la-lock" />}
					/>
					<InputField
						label="Status"
						value={request.status || 'pending'}
						disabled={true}
						inputIcon={<i className="las la-lock" />}
					/>
				</div>
			</div>
		);
	};

	renderCalendarData = () => {
		const { request } = this.state;
		const { bookingPage } = this.props;
		if (!request?.selectedDateTimes) {
			return (
				<div className="sectionBody pt-0">
					<div className="sectionBlock">
							<h2 className="blockHeader">Requested Time Slots</h2>
						<p className="small mb-20">No calendar requests available</p>
					</div>
				</div>
			);
		}

		const calendarsMap = {};
		bookingPage?.calendars?.forEach(cal => {
			calendarsMap[cal._id] = cal;
		});

		return (
			<div className="sectionBody pt-0">
				<div className="sectionBlock">
					<h2 className="blockHeader">Requested Time Slots</h2>
					<p className="small mb-20">Review and approve/deny individual time slots requested by the customer.</p>

					{Object.keys(request.selectedDateTimes).map(date => (
						<div key={date} className="mb-30">
							<h3 className="mb-15">{moment(date).format("dddd, MMMM Do, YYYY")}</h3>

							{Object.keys(request.selectedDateTimes[date]).map(calendarId => {
								const calendar = calendarsMap[calendarId];
								const timeSlots = request.selectedDateTimes[date][calendarId];

								return (
									<div key={calendarId} className={`card p-10 mb-20`}>
										<h4 className="mb-10">{calendar?.name || 'Unknown Calendar'}</h4>

										<div className="flex column">
											{timeSlots.map((timeSlot, index) => {
												let isBooked = this.isTimeSlotBooked(calendarId, date, timeSlot);
												const wasDenied = request.deniedTimes?.[date]?.[calendarId]?.includes(timeSlot);
												const wasApproved = request.approvedTimes?.[date]?.[calendarId]?.includes(timeSlot);
												const hasRegistrantConflict = this.hasRegistrantConflict(request, date, timeSlot);
												const available = !isBooked && !wasApproved && !wasDenied && !hasRegistrantConflict;
												console.log('Time slot:', timeSlot, 'isBooked:', isBooked, 'wasDenied:', wasDenied, 'wasApproved:', wasApproved, 'hasRegistrantConflict:', hasRegistrantConflict);
												const endTime = moment(`${date} ${timeSlot}`).add(bookingPage.meetingDuration, bookingPage.durationUnit).format("h:mm A");
												return (
													<div key={index} className={`bookingRequestSlot ${!available ? 'disabled' : 'available'} ${wasDenied ? 'denied' : ''} ${hasRegistrantConflict ? 'conflict' : ''}`}>
														<div className="flex aic jcsb">
															<div className="flex aic gap10">
																<strong>{timeSlot} - {endTime}</strong>
															</div>

															{available && <div className="flex aic gap10">
																<button
																	className="prim"
																	disabled={isBooked || hasRegistrantConflict}
																	onClick={() => this.approveTimeSlot(request._id, date, calendarId, timeSlot)}
																>
																	<i className="las la-check" />
																</button>
																<button
																	className="danger"
																	onClick={() => this.denyTimeSlot(request._id, date, calendarId, timeSlot)}
																>
																	<i className="las la-times" />
																</button>
															</div>}
															{wasApproved && <span className="text-success">Approved</span>}
															{wasDenied && <span className="text-danger">Denied</span>}
															{hasRegistrantConflict && !wasApproved && !wasDenied && <span className="text-warning"><i className="las la-user-times" /> Registrant Conflict</span>}
														</div>
														{index < timeSlots.length - 1 && <hr className="my-10" />}
													</div>
												);
											})}
										</div>
									</div>
								);
							})}
						</div>
					))}
				</div>
			</div>
		);
	};


	renderSelectedCalendars = () => {
		const { request } = this.state;
		const { bookingPage } = this.props;

		if (!request.selectedCalendars || request.selectedCalendars.length === 0) {
			return (
				<div className="sectionBody pt-0">
					<div className="sectionBlock">
						<h2 className="blockHeader">Requested Calendars</h2>
						<p>No calendars have been requested</p>
					</div>
				</div>
			);
		}

		return (
			<div className="sectionBody pt-0">
				<div className="sectionBlock">
					<h2 className="blockHeader">Requested Calendars</h2>
					<p className="small mb-20">Review and manage individual calendar requests.</p>

					{request.selectedCalendars.map(calendarId => {
						const calendar = bookingPage.calendars.find(cal => cal._id === calendarId);
						const calendarStartDate = moment(calendar?.startDate).format("MMMM Do YYYY");
						const calendarEndDate = moment(calendar?.endDate).format("MMMM Do YYYY");
						const durationUnit = bookingPage.durationUnit; //minutes or hours


						// Calculate summary data for this calendar
						const registrantBookedDates = [];
						const registrantBookedSlots = 0;

						// Get all approved times for this registrant on this calendar
						if (request.approvedTimes) {
							Object.keys(request.approvedTimes).forEach(approvedDate => {
								if (request.approvedTimes[approvedDate][calendarId]) {
									const slotsForDate = request.approvedTimes[approvedDate][calendarId];
									if (slotsForDate && slotsForDate.length > 0) {
										registrantBookedDates.push(approvedDate);
									}
								}
							});
						}

						// Calculate total booked slots
						const bookedSlotsCount = registrantBookedDates.reduce((total, date) => {
							return total + (request.approvedTimes[date][calendarId]?.length || 0);
						}, 0);

						// Format approved slots by date for display
						let formattedApprovedSlots = '';
						let summaryText = '';

						let approvedDatesAndTimesObj = {};

						if (registrantBookedDates.length > 0) {
							formattedApprovedSlots = 'Approved Slots\n';

							registrantBookedDates.forEach(date => {
								const formattedDate = moment(date).format("MMMM Do, YYYY");

								approvedDatesAndTimesObj[formattedDate] = approvedDatesAndTimesObj[formattedDate] || [];



								// Get all approved time slots for this date
								const approvedSlots = request.approvedTimes[date][calendarId] || [];
								approvedDatesAndTimesObj[formattedDate] = approvedSlots;
							});

							summaryText = `${bookedSlotsCount} approved time slot${bookedSlotsCount > 1 ? 's' : ''} on ${registrantBookedDates.length} date${registrantBookedDates.length > 1 ? 's' : ''}`;
						} else {
							summaryText = 'No approved time slots yet';
							formattedApprovedSlots = 'No approved slots';
						}


						return (
							<div key={calendarId} className="mb-30">
								<div className="flex w-100">
									<div className="card p-20 mb-20 w-100">
										<div className="flex jcsb aic">
											<div>
												<h3 className="mb-0">{calendar?.name || 'Unknown Calendar'}</h3>
												<p className="gray small mb-15">Available {calendarStartDate} to {calendarEndDate}</p>
											</div>
											<button className="" onClick={() => {

												let requestedCalendarsViewUpdate = this.state.requestedCalendarsView;

												if (requestedCalendarsViewUpdate[calendarId]) {
													delete requestedCalendarsViewUpdate[calendarId];
												} else {
													requestedCalendarsViewUpdate[calendarId] = {};
												}

												this.setState({ requestedCalendarsView: requestedCalendarsViewUpdate });
											}}>

												{this.state.requestedCalendarsView[calendarId] ? <i className="las la-angle-down"></i> : <i class="las la-angle-up"></i>}
											</button>
										</div>

										<div>
											<div className="mb-20">
												<h4 className="mb-10">Approved Slots</h4>
												<div className="flex column gap10">
													{Object.entries(approvedDatesAndTimesObj).map(([date, times]) => (
														<div key={date}>
															<strong>{date}</strong><br />
															{times.join(', ')}
														</div>
													))}
													{Object.keys(approvedDatesAndTimesObj).length === 0 && (
														<div>No approved slots</div>
													)}
												</div>
											</div>


										</div>

										{this.state.requestedCalendarsView[calendarId] && (
											<div className="mb-20">
												<h4 className="mb-10">Available Time Slots by Date</h4>

												{(() => {
													const startDate = moment(calendar?.startDate);
													const endDate = moment(calendar?.endDate);
													const dates = [];
													const current = moment.max(moment(startDate), moment().startOf('day')); // Start from today or startDate, whichever is later

													while (current.isSameOrBefore(endDate)) {
														const dayOfWeek = current.format('dddd').toLowerCase();
														const dayConfig = calendar.schedule?.[dayOfWeek];

														if (dayConfig?.available && dayConfig.availableTimeRanges?.length > 0) {
															const formattedDate = current.format('MMMM Do, YYYY');

															dates.push(
																<div key={current.format('YYYY-MM-DD')} className="mb-15">
																	<div className="flex jcsb aic mb-10">
																		<div>
																			<h5 className="mb-5">{formattedDate} ({current.format('dddd')})</h5>
																		</div>
																		<button className="" onClick={() => {
																			let requestedCalendarsViewUpdate = this.state.requestedCalendarsView;

																			if (requestedCalendarsViewUpdate[calendarId] && requestedCalendarsViewUpdate[calendarId][formattedDate]) {
																				requestedCalendarsViewUpdate[calendarId][formattedDate] = false;
																			} else {
																				requestedCalendarsViewUpdate[calendarId][formattedDate] = true;
																			}
																			this.setState({ requestedCalendarsView: requestedCalendarsViewUpdate });
																		}}>

																			{this.state.requestedCalendarsView[calendarId][formattedDate] ? <i className="las la-angle-down"></i> : <i className="las la-angle-up"></i>}
																		</button>
																	</div>

																	{this.state.requestedCalendarsView[calendarId][formattedDate] && (
																		<div className="gap10">
																			{dayConfig.availableTimeRanges.map((range, idx) => {
																				// Generate each individual time slot based on meeting duration
																				const slots = [];
																				const startTime = moment(`${current.format('YYYY-MM-DD')} ${range.startTime}`, 'YYYY-MM-DD h:mm A');
																				const endTime = moment(`${current.format('YYYY-MM-DD')} ${range.endTime}`, 'YYYY-MM-DD h:mm A');

																				let slotTime = moment(startTime);

																				while (slotTime.isBefore(endTime)) {

																					const slotStr = slotTime.format('h:mm A');
																					// Check if this slot is fully booked
																					const slotDate = current.format('YYYY-MM-DD');
																					const slotTimeStr = slotTime.format('h:mm A');

																					// Count how many bookings already exist for this time slot
																					const bookingsCount = calendar.bookedSpots?.filter(
																						spot => {
																							let bookedSpotTime = spot.time;
																							let bookedSpotDate = spot.date;
																							let isSameTime = bookedSpotDate === slotDate && bookedSpotTime === slotTimeStr;

																							return isSameTime;

																						}
																					)?.length || 0;

																					const maxSpots = calendar.maxSpots || 1;

																					let isAvailable = calendar.limitSpots ? bookingsCount < maxSpots : true;
																					if (isAvailable) {

																						let approvedTimes = request.approvedTimes;
																						if (!approvedTimes?.[slotDate]?.[calendarId]?.includes(slotTimeStr)) {
																							let registrant = bookingPage.registrants.find(r => r._id === request.registrant);
																							let reservedDateTimes = registrant?.reservedDateTimes || [];

																							// Check if the time slot falls within any reserved time ranges
																							let isBlackOutDate = false;

																							let beginTime = slotStr;
																							let endTime = moment(slotTime).add(bookingPage.meetingDuration, durationUnit).format('h:mm A');

																							// Convert slot time to moment objects for comparison
																							const slotStartMoment = moment(`${slotDate} ${beginTime}`, 'YYYY-MM-DD h:mm A');
																							const slotEndMoment = moment(`${slotDate} ${endTime}`, 'YYYY-MM-DD h:mm A');

																							// Check if the current time slot overlaps with any reserved date time ranges
																							for (const reservation of reservedDateTimes) {
																								const reservationStart = moment(`${reservation.startDate} ${reservation.startTime}`, 'YYYY-MM-DD h:mm A');
																								const reservationEnd = moment(`${reservation.endDate} ${reservation.endTime}`, 'YYYY-MM-DD h:mm A');

																								// Check for overlap between the slot and the reservation
																								if (
																									(slotEndMoment.isAfter(reservationStart) && slotEndMoment.isSameOrBefore(reservationEnd)) ||
																									(slotStartMoment.isSameOrBefore(reservationStart) && slotEndMoment.isSameOrAfter(reservationEnd))
																								) {
																									isBlackOutDate = true;
																									break;
																								}
																							}

																							if (isBlackOutDate) {

																								slots.push(
																									<div key={`${idx}-${slotStr}`} className="flex jcsb aic mb-10 w-100">
																										<div>
																											{beginTime} - {endTime}
																											{maxSpots > 1 && <span className="small text-muted ml-5">({bookingsCount}/{maxSpots} booked)</span>}
																										</div>
																										<div className="text-danger ml-a"><i className="las la-ban"></i> Blackout Time</div>
																									</div>
																								);



																							} else {

																								slots.push(
																									<div key={`${idx}-${slotStr}`} className="flex jcsb aic mb-10">
																										<div>
																											{beginTime} - {endTime}
																											{maxSpots > 1 && <span className="small text-muted ml-5">({bookingsCount}/{maxSpots} booked)</span>}
																										</div>
																										<button
																											className="prim sm"
																											onClick={() => {

																												this.approveTimeSlot(request._id, slotDate, calendarId, slotTimeStr)
																											}}
																										>
																											<i className="las la-check"></i> Approve
																										</button>
																									</div>
																								);



																							}









																						} else {
																							slots.push(
																								<div key={`${idx}-${slotStr}`} className="flex jcsb aic mb-10">
																									<div>
																										{slotStr} - {moment(slotTime).add(bookingPage.meetingDuration, durationUnit).format('h:mm A')}
																										{maxSpots > 1 && <span className="small text-muted ml-5">({bookingsCount}/{maxSpots} booked)</span>}
																									</div>
																									<span className="text-success"><i className="las la-check-circle"></i> Approved</span>
																								</div>
																							);
																						}
																					}

																					slotTime.add(bookingPage.meetingDuration, durationUnit);
																				}

																				return slots;
																			})}
																		</div>
																	)}
																</div>
															);
														}

														current.add(1, 'days');
													}

													return dates.length ? dates : <p>No available time slots in this date range</p>;
												})()}
											</div>)}

									</div>
								</div>
							</div>
						);
					})}
				</div>
			</div>
		);
	};

	render() {
		const { selectedSection, request, loading } = this.state;
		const { bookingPage } = this.props;

		if (!request) {
			return <div className="p-20">Request not found</div>;
		}

		return (
			<div className="sectionContainer">
				<SectionHeader
					title="Booking Request"
					description={`Request from ${request.customerName} - Review and manage individual time slot requests`}
					closeButton={true}
				/>

				<div className="sectionHeaderChildren">
					<TabsContainer
						tabs={tabs}
						updateSelected={this.updateSelected}
						selectedIndex={tabs.findIndex((t) => t.id === selectedSection)}
					/>
				</div>

				{selectedSection === 'submission' && this.renderSubmissionData()}
				{selectedSection === 'calendar' && this.renderCalendarData()}
				{selectedSection === 'requestedCalendars' && this.renderSelectedCalendars()}

				<SectionFooter
					editing={false}
					updatedAt={request.updatedAt || request.createdAt}
				/>

				<LoadingWizard loading={loading} />
			</div>
		);
	}
}

export default withRouter(RequestDetail);
